<template>
  <section v-if="shipment_detail" :key="countRq">
    <validation-observer ref="requestSubmit">
      <!-- Order Information -->
      <b-row class="px-2">
        <b-col cols="12" class="pt-1">
          <h4>Order Information</h4>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="">
            <b-form-group>
              <label>Customer </label>

              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="true" placeholder="Select Company"
                v-model="shipment_detail.customer_company_id" :options="companyItems" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="">
            <b-form-group>
              <label>Service Mode </label>

              <Select2 :disabled="true" :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="Select Service Type" v-model="shipment_detail.service_type" :options="service_types" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-group>
            <label>Order ID</label>
            <b-form-input :disabled="true" v-model="shipment_detail.id" />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="">
            <b-form-group>
              <label>Customer Contact </label>
              <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    v-model="shipment_on_tms.customer_name"
                    placeholder="Customer Contact"
                  /> -->
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly"
                placeholder="Select Customer" v-model="shipment_detail.customer_id" :options="customer_list_options" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Phone" #default="{ errors }" rules="">
            <b-form-group>
              <label>Phone </label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.customer_phone" placeholder="Phone" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Phone" #default="{ errors }" rules="">
            <b-form-group>
              <label>Email </label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.customer_email" placeholder="Phone" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Contact WR1" #default="{ errors }" rules="">
            <b-form-group>
              <label>Contact WR1 </label>

              <Select2 :disabled="readonly" v-model="shipment_detail.sale_id" :options="sales" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider name="Phone" #default="{ errors }" rules="">
            <b-form-group>
              <label>Phone </label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.sale_phone" placeholder="Phone" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Phone" #default="{ errors }" rules="">
            <b-form-group>
              <label>Email </label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.sale_email" placeholder="Phone" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <!-- END Order Information -->
      <b-row class="px-2">
        <b-col cols="12" class="pt-1">
          <h4>Freight Informations</h4>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider :name="shipment_detail.service_type == 1 ? 'AOL' : 'POL'" #default="{ errors }"
            rules="required">
            <b-form-group>
              <label>{{
                shipment_detail.service_type == 1 ? "AOL" : "POL"
              }}<font class="red">*</font>
              </label>
              <!-- <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="AOL/POL"
                v-model="shipment_detail.pol_port"
                :options="ports"
              /> -->
              <Select4 v-model="shipment_detail.pol_port" :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOL/POL" :disabled="readonly" :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider :name="shipment_detail.service_type == 1 ? 'AOD' : 'POD'" #default="{ errors }"
            rules="required">
            <b-form-group>
              <label>{{
                shipment_detail.service_type == 1 ? "AOD" : "POD"
              }}<font class="red">*</font></label>

              <!-- <Select2
                :class="errors.length > 0 ? 'is-invalid' : null"
                :disabled="readonly"
                placeholder="AOD/POL"
                v-model="shipment_detail.pod_port"
                :options="ports"
              /> -->
              <Select4 v-model="shipment_detail.pod_port" :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOD/POL" :disabled="readonly" :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Payment Terms" #default="{ errors }" rules="">
            <b-form-group>
              <label>Payment Terms</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Payment Terms"
                v-model="shipment_detail.paymentTerms" :options="$Options.paymentTerms" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Cargo ready" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Cargo ready<font class="red">*</font></label>
              <!-- <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.cargo_ready"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              /> -->
              <date-picker ref="datePicker" v-model="shipment_detail.cargo_ready" type="datetime" class="w-full"
                :class="errors.length > 0 ? 'is-invalid' : null" value-type="format" :disabled="readonly"
                title-format="DD-MM-YYYY" time-title-format="DD-MM-YYYY" placeholder="Select datetime"
                :show-time-panel="showTimePanel" format="DD-MM-YYYY HH:mm" @close="handleOpenChange">
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel? "Date": "Time" }}
                  </button>
                </template>
              </date-picker>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!--  Carrier -->

        <b-col cols="12" lg="6">
          <validation-provider name="        Airline
" #default="{ errors }" rules="">
            <b-form-group>
              <label>Airline</label>

              <Select4 v-model="shipment_detail.shipping_line" :class="[
                errors.length > 0 ? 'is-invalid' : null,
                readonly == true ? 'remove' : '',
              ]" placeholder="Airline" :disabled="readonly" :options="{
  value: 'id',
  label: 'text',
  data: shipping_lines,
  fields: [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Shipping Line' },
  ],
}" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- <b-col cols="12" :lg="isVolume ? '6' : '4'" v-if="!isVolume">
          <b-form-group>
            <label>Volume (Monthly)</label>
            <Select2
              :disabled="readonly"
              placeholder="Volume (Monthly)"
              v-model="shipment_detail.volume"
              :options="$Utils.CONSTANTS.VOLUMES"
            />
          </b-form-group>
        </b-col> -->
        <!-- 
        <b-col cols="12" lg="6">
          <validation-provider
            name="From"
            #default="{ errors }"
            rules="required"
          >
            <b-form-group>
              <label>From<font class="red">*</font></label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                :min="new Date()"
                v-model="shipment_detail.from_date"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="To" #default="{ errors }" rules="required">
            <b-form-group>
              <label>To<font class="red">*</font></label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                :min="
                  shipment_detail.from_date
                    ? new Date(shipment_detail.from_date)
                    : new Date()
                "
                v-model="shipment_detail.to_date"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col> -->
        <b-col cols="6">
          <validation-provider name="ETD" #default="{ errors }" rules="">
            <b-form-group>
              <label>ETD </label>
              <b-form-datepicker :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.etd" :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="vi-VN" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider name="ETA" #default="{ errors }" rules="">
            <b-form-group>
              <label>ETA</label>
              <b-form-datepicker :state="errors.length > 0 ? false : null" v-model="shipment_detail.eta"
                :disabled="readonly" :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="vi-VN" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="required">
            <label>Place of Receipt</label>

            <b-form-input placeholder="Enter Place of Receipt" :disabled="readonly"
              v-model="shipment_detail.placeOfDelivery" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="required">
            <label>Place of Delivery</label>

            <b-form-input placeholder="Enter Place of Delivery" :disabled="readonly"
              v-model="shipment_detail.placeOfDelivery" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider #default="{ errors }" rules="required">
            <label>B/L</label>
            <b-form-input :class="errors.length > 0 ? 'is-invalid' : null" v-model="shipment_detail.HBL"
              :disabled="readonly" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col cols="12" class="pt-1">
          <h4>Cargo Information</h4>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider name="Commodity" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Commodity<font class="red">*</font></label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Commodity"
                v-model="shipment_detail.goods_type" :options="goods_types" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Commodity description" #default="{ errors }" rules="">
            <b-form-group>
              <label>Commodity description</label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.mo_ta" placeholder="Commodity description" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Gross Weight (kgs)" #default="{ errors }" rules="">
            <b-form-group>
              <label>Total Gross Weight (kg)</label>
              <!-- <b-form-input
                type="number"
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="shipment_detail.trong_luong"
                placeholder="Gross Weight (kgs)"
              /> -->
              <cleave :state="errors.length > 0 ? false : null" :options="$Utils.CONSTANTS.cleaveNumeral"
                :disabled="readonly" v-model="shipment_detail.trong_luong" class="form-control"
                placeholder="Gross Weight (kgs)" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <b-form-group>
            <label>Measurement (cbm)</label>
            <!-- <b-form-input
              type="number"
              :disabled="readonly"
              v-model="shipment_detail.so_khoi"
              placeholder="Measurement (kgs)"
            /> -->
            <cleave :options="$Utils.CONSTANTS.cleaveNumeral" :disabled="readonly" v-model="request_quotation.so_khoi"
              class="form-control" placeholder="Measurement (kgs)" />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Handled type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Handled type</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Handled type"
                v-model="shipment_detail.handled_type" :options="handed_types" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Total Charge Weight (kg)" #default="{ errors }" rules="">
            <b-form-group>
              <label>Total Charge Weight (kg)</label>
              <cleave :options="$Utils.CONSTANTS.cleaveNumeral" :state="errors.length > 0 ? false : null"
                :disabled="true" v-model="shipment_detail.totalChargeWeight" class="form-control"
                placeholder="Total Charge Weight (kg)" />
              <!-- <b-form-input
                    :state="errors.length > 0 ? false : null"
                    :disabled="readonly"
                    v-model="request_quotation.totalChargeWeight"
                    placeholder="Total Charge Weight (kg)"
                  /> -->
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Package type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Package type</label>

              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Package type"
                v-model="shipment_detail.package_type" :options="cont_types.filter((i) => i.group === 'packaging')" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="6">
          <validation-provider name="Package Number" #default="{ errors }" rules="">
            <b-form-group>
              <label>Package Number</label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.packageNumber" placeholder="Package Number" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- Van -->

        <b-col cols="12" class="pt-1">
          <h4>Shipment Informations</h4>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Booking/HBL/INV</label>
            <b-form-input :disabled="readonly" placeholder="Booking/HBL/INV" v-model="shipment_detail.HBL" />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Shipping Type</label>
            <Select2 :disabled="readonly" placeholder="Shipping Type" v-model="shipment_detail.shippingType" :options="
              request_quotation.service_type == 5
                ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                : request_quotation.service_type == 6
                  ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                  : transport_types.filter((i) => [1, 2].includes(i.id))
            " />
          </b-form-group>
        </b-col>

        <!-- new shipment -->
        <b-col cols="12" lg="4">
          <validation-provider name="Shipper" #default="{ errors }" rules="">
            <b-form-group>
              <label>Shipper </label>
              <div class="d-flex">
                <Select3 v-model="shipment_detail.shipper" :disabled="readonly" @select="
                  ({ name, Address }) => {
                    shipment_detail.shipper_name = name;
                    shipment_detail.shipper_address = Address;
                  }
                " :options="{
  value: 'id',
  label: 'name',
  url: 'masterData?data=ShipperConsignee',
  fields: [
    { field: 'name', label: 'Name' },
    {
      field: 'Address',
      label: 'Address',
    },
  ],
}" />
              </div>

              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Consignee" #default="{ errors }" rules="">
            <b-form-group>
              <label>Consignee </label>

              <Select3 v-model="shipment_detail.consignee" :disabled="readonly" @select="
                ({ name, Address }) => {
                  shipment_detail.consignee_name = name;
                  shipment_detail.consignee_address = Address;
                }
              " :options="{
  value: 'id',
  label: 'name',
  url: 'masterData?data=ShipperConsignee',
  fields: [
    { field: 'name', label: 'Name' },
    {
      field: 'Address',
      label: 'Address',
    },
  ],
}" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Company" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Agent </label>

              <Select4 v-model="shipment_detail.agent" :disabled="readonly"
                :class="errors.length > 0 ? 'is-invalid' : null" placeholder="Select Company" :options="{
                  value: 'code',
                  label: 'text',
                  data: companyItems,
                  fields: [
                    { field: 'code', label: 'Tax Code' },
                
                    { field: 'name', label: 'Name' },
                    {
                      field: 'acronym',
                      label: 'Acronym',
                    },
                  ],
                }" />
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- end new shipment -->

        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="Truck Type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Truck Type</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Truck Type"
                v-model="shipment_detail.truck_type" :options="cont_types.filter((i) => i.group === 'van truck')" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="Quantity" #default="{ errors }" rules="">
            <b-form-group>
              <label>Quantity</label>
              <b-form-input placeholder="Quantity" type="number" :state="errors.length > 0 ? false : null"
                :disabled="readonly" v-model="shipment_detail.so_luong" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="Pick up" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Pick up<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <!-- <Select2
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  class="hide_select"
                  :disabled="readonly"
                  v-if="!shipment_detail.isHideShows"
                  placeholder="Pick up"
                  v-model="shipment_detail.pickup_location"
                  :options="locations"
                /> -->
                <Select4 v-model="shipment_detail.pickup_location" v-if="!shipment_detail.isHideShows"
                  :classProp="errors.length > 0 ? 'is-invalid' : null" placeholder="Pick up" :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: locations,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }" />
                <b-form-input v-if="shipment_detail.isHideShows" :state="errors.length > 0 ? false : null"
                  :disabled="readonly" v-model="shipment_detail.other_pickup_location" placeholder="Enter pick up " />
                <b-form-checkbox :disabled="readonly" v-on:change="hideShows" v-model="shipment_detail.isHideShows"
                  class="check_input">Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="Delivery" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Delivery<font class="red">*</font></label>
              <div class="d-flex align-items-center">
                <Select4 v-model="shipment_detail.delivery_location" v-if="!shipment_detail.isHideShowPk"
                  :classProp="errors.length > 0 ? 'is-invalid' : null" placeholder="Delivery" :disabled="readonly"
                  :options="{
                    value: 'id',
                    label: 'text',
                    data: locations,
                    fields: [
                      { field: 'abbreviations', label: 'Abbreviations' },
                      { field: 'name', label: 'Location' },
                      {
                        field: 'address',
                        label: 'Address',
                      },
                    ],
                  }" />
                <b-form-input v-if="shipment_detail.isHideShowPk" :state="errors.length > 0 ? false : null"
                  :disabled="readonly" v-model="shipment_detail.other_delivery_location" placeholder="Enter pick up" />
                <b-form-checkbox :disabled="readonly" v-on:change="hideShowsPk" v-model="shipment_detail.isHideShowPk"
                  class="check_input">Other
                </b-form-checkbox>
              </div>
              <small class="text-danger" v-show="errors.length > 0">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="PIC pick up" #default="{ errors }" rules="">
            <b-form-group>
              <label>Pick up date</label>

              <section>
                <date-picker ref="datePicker" v-model="shipment_detail.pick_up_date" type="datetime" class="w-full"
                  :disabled="readonly" value-type="format" title-format="DD-MM-YYYY"
                  :state="errors.length > 0 ? false : null" time-title-format="DD-MM-YYYY" placeholder="Select datetime"
                  :show-time-panel="showTimePanel" format="DD-MM-YYYY HH:mm" @close="handleOpenChange">
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                      {{ showTimePanel? "Date": "Time" }}
                    </button>
                  </template>
                </date-picker>
              </section>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="PIC pick up" #default="{ errors }" rules="">
            <b-form-group>
              <label>Delivery Date</label>

              <section>
                <date-picker ref="datePicker" v-model="shipment_detail.delivery_date"
                  :disabled-date="disabledRangeDelivery" type="datetime" class="w-full" value-type="format"
                  :disabled="readonly" :state="errors.length > 0 ? false : null" title-format="DD-MM-YYYY"
                  time-title-format="DD-MM-YYYY" placeholder="Select datetime" :show-time-panel="showTimePanel"
                  format="DD-MM-YYYY HH:mm" @close="handleOpenChange">
                  <template v-slot:footer>
                    <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                      {{ showTimePanel? "Date": "Time" }}
                    </button>
                  </template>
                </date-picker>
              </section>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="PIC pick up" #default="{ errors }" rules="">
            <b-form-group>
              <label>PIC pick up</label>
              <b-form-input placeholder="PIC pick up" :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.PICPickUp" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6" v-if="shipment_detail.has_van_trucking">
          <validation-provider name="PIC Delivery" #default="{ errors }" rules="">
            <b-form-group>
              <label>PIC Delivery</label>
              <b-form-input placeholder="PIC Delivery" :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="shipment_detail.PICDelivery" />
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- end Van -->

        <!-- Custom  -->

        <b-col cols="12" v-if="shipment_detail.has_customs">
          <b-row>
            <b-col v-if="shipment_detail.has_customs" cols="12" lg="12" class="pt-1">
              <h4>Customs declaration information</h4>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>Customs type</label>
                <Select2 :disabled="readonly" placeholder="Customs type" v-model="shipment_detail.customs_type"
                  :options="customs_types" />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider name="Business type" #default="{ errors }" rules="required">
                <b-form-group>
                  <label>Business type<font class="red">*</font></label>
                  <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly"
                    placeholder="Business type" v-model="shipment_detail.business_type" :options="business_types" />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <validation-provider name="Place of Custom declaration" #default="{ errors }" rules="required">
                <b-form-group>
                  <label>Place of Custom declaration<font class="red">*</font></label>
                  <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                    v-model="shipment_detail.customs_addr" placeholder="Place of Custom declaration" />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <label>HS Code</label>
                <b-form-input :disabled="readonly" v-model="shipment_detail.hs_code" placeholder="HS Code" />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- end custom -->
        <b-col cols="12">
          <b-form-group>
            <label>Notes</label>
            <b-form-textarea rows="5" :disabled="readonly" v-model="shipment_detail.notes" placeholder="Notes" />
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </section>
</template>

<script>
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Select2 from "v-select2-component";
import moment from "moment";
import { mapState, mapActions } from "vuex";
import mixins from "./mixin/mixin";
export default {
  mixins: [mixins],

  props: [
    "request_quotation",
    "shipment_on_tms",
    "shipment_on_fast",
    "shipment_details",
  ],
  components: {
    ValidationProvider,
    Select2,
    ValidationObserver,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      maxFiles: false,
      isHideShowBookingEdit: false,
      isHideShowPkBookingEdit: false,
      cut_off: "",
      shipment_detail: {
        so_khoi: null,
        trong_luong: null,
        totalChargeWeight: null,
        pick_up_date: null,
        delivery_date: null,
      },
      moment,

      useLocations: [],
    };
  },
  watch: {
    cut_off(n) {
      this.$emit("cut-off", n);
    },
    ...["shipment_detail.so_khoi", "shipment_detail.trong_luong"].reduce(
      (watchers, key) => ({
        ...watchers,
        [key](newVal, oldVal) {
          var vm = this;

          if (vm.shipment_detail.service_type == 1) {
            vm.shipment_detail.trong_luong > vm.shipment_detail.so_khoi * 167
              ? (vm.shipment_detail.totalChargeWeight =
                vm.shipment_detail.trong_luong)
              : (vm.shipment_detail.totalChargeWeight =
                vm.shipment_detail.so_khoi * 167);
          }
        },
      }),
      {}
    ),
  },
  computed: {
    ...mapState("masterData", [
      "ports",
      "cont_types",
      "goods_types",
      "transport_types",
      "regions",
      "deports_locations",
      "service_types",
      "business_types",
      "customs_types",
      "incoterms",
      "sales",
      "companyItems",
      "regions",
      "company_list",
      "shipping_lines",
      "customer_list_options",
      "handed_types",
    ]),
    readonly() {
      return (
        this.request_quotation && this.request_quotation.accept_edit != 1 ||
        this.request_quotation.locked == 1 ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Client ||
        this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Client_Root
        || this.request_quotation.status_id == 63
      );
    },
  },

  created() {
    this.$loading.show();
    if (this.request_quotation || this.shipment_details) {
      this.getUserLocation(this.request_quotation.customer_id);

      if (!this.isBlank(this.shipment_details)) {
        this.shipment_detail = this.shipment_details;
      } else {
        // console.log(this.request_quotation);
        this.shipment_detail.id = this.request_quotation.bookingID;
        this.shipment_detail.agent = this.shipment_on_fast?.agent;

        this.shipment_detail.service_type = this.request_quotation.service_type;
        this.shipment_detail.has_customs =
          this.request_quotation?.has_customs || false;
        this.shipment_detail.shippingType =
          this.request_quotation?.shippingType;
        // this.shipment_detail.files = this.request_quotation.files;

        this.shipment_detail.deport =
          this.request_quotation.deport;

        this.shipment_detail.cont_type = this.request_quotation.cont_type;

        this.shipment_detail.goods_type = this.request_quotation.goods_type;

        this.shipment_detail.trong_luong = this.request_quotation.trong_luong;

        this.shipment_detail.shipping_line =
          this.request_quotation.shipping_line;

        this.shipment_detail.BL =
          (this.request_quotation.shipment_info &&
            this.request_quotation.shipment_info.find((e) => e.id == "4.1")
              ?.hbl) ||
          "";

        this.shipment_detail.container_no = this.request_quotation.container_no;

        this.shipment_detail.seal_no = this.request_quotation.seal_no;

        this.shipment_detail.business_type =
          this.request_quotation.business_type;

        this.shipment_detail.customs_addr = this.request_quotation.customs_addr;

        this.shipment_detail.hs_code = this.request_quotation.hs_code;

        this.shipment_detail.notes = this.request_quotation.notes;

        this.shipment_detail.billingInformation =
          this.request_quotation.billingInformation;
        this.shipment_detail.so_luong = this.request_quotation.so_luong;
        this.shipment_detail.customs_type = this.request_quotation.customs_type;

        this.shipment_detail.pickup_location =
          this.request_quotation.pickup_location;
        this.shipment_detail.delivery_location =
          this.request_quotation.delivery_location;

        this.shipment_detail.shipper = this.shipment_on_fast.shipper;
        this.shipment_detail.shipper_name =   this.shipment_on_fast.shipper_name
        this.shipment_detail.consignee = this.shipment_on_fast.consignee;
        this.shipment_detail.consignee_name = this.shipment_on_fast.consignee_name;
        this.shipment_detail.vessel = this.shipment_on_fast.vessel
        this.shipment_detail.voyage = this.shipment_on_fast.voyage


        this.shipment_detail.placeOfDelivery =
          this.shipment_on_fast.placeOfDelivery;

        this.shipment_detail.customer_id = this.request_quotation.customer_id;
        this.shipment_detail.customer_name =
          this.request_quotation.customer_name;
        this.shipment_detail.customer_phone =
          this.request_quotation.customer_phone;
        this.shipment_detail.customer_email =
          this.request_quotation.customer_email;

        this.shipment_detail.sale_id = this.request_quotation.sale_id;
        this.shipment_detail.sale_name = this.request_quotation.sale_name;
        this.shipment_detail.sale_phone = this.request_quotation.sale_phone;

        this.shipment_detail.sale_email = this.request_quotation.sale_email;
        this.shipment_detail.customer_company_id =
          this.request_quotation.company_id;
        this.shipment_detail.pick_up_date = this.request_quotation.pick_up_date;
        this.shipment_detail.delivery_date =
          this.request_quotation.delivery_date;

        this.shipment_detail.PICPickUp = this.request_quotation.PICPickUp;
        this.shipment_detail.PICDelivery = this.request_quotation.PICDelivery;
        this.shipment_detail.pol_port = this.request_quotation.pol_port;

        this.shipment_detail.pod_port = this.request_quotation.pod_port;
        this.shipment_detail.paymentTerms = this.request_quotation.paymentTerms;
        this.shipment_detail.cargo_ready = this.request_quotation.cargo_ready;

        this.shipment_detail.etd = this.request_quotation.etd;
        this.shipment_detail.eta = this.request_quotation.eta;
        this.shipment_detail.placeOfDelivery =
          this.request_quotation.placeOfDelivery;

        this.shipment_detail.placeOfReceipt =
          this.request_quotation.placeOfReceipt;
        this.shipment_detail.mo_ta = this.request_quotation.mo_ta;

        this.shipment_detail.so_khoi = this.request_quotation.so_khoi;
        this.shipment_detail.handled_type = this.request_quotation.handled_type;

        this.shipment_detail.dimension = this.request_quotation.dimension;

        this.shipment_detail.package_type = this.request_quotation.package_type;

        this.shipment_detail.packageNumber =
          this.request_quotation.packageNumber;
        this.shipment_detail.HBL = this.request_quotation.HBL
          ? this.request_quotation.HBL
          : "";
        this.shipment_detail.has_van_trucking =
          this.request_quotation.has_van_trucking;
      }
    }
  },
  mounted() {
    this.cut_off = this.shipment_detail.cut_off;
    this.$store.commit("masterData/SET_SHIPPING_DETAIL", this.shipment_detail);

  },
  methods: {
    disabledRangeDelivery: function (date) {
      if (this.shipment_detail.pick_up_date) {
        var mydate = moment(this.shipment_detail.pick_up_date, "DD/MM/YYYY");

        //format that date into a different format
        var now = moment(mydate).format("MM/DD/YYYY");

        return date < new Date(now);
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    hideShows: function () {
      this.isHideShow = !this.isHideShow;
      if (!this.isHideShow) {
        this.shipment_detail.pickup_location = "";
      }
    },
    hideShowsPk: function () {
      this.isHideShowPk = !this.isHideShowPk;
      if (!this.isHideShowPk) {
        this.shipment_detail.delivery_location = "";
      }
    },
    changeHideShows: function () {
      this.isHideShowBookingEdit = !this.isHideShowBookingEdit;
    },
    changeHideShowsPk: function () {
      this.isHideShowPkBookingEdit = !this.isHideShowPkBookingEdit;
    },
  },
};
</script>

<style>

</style>